export default "__VITE_ASSET__abb4a003__"